export default () => `
<div>
  <div  height="550" width="450">
    <img src="https://i.ibb.co/Gx64D34/untitled.png" height="400" width="300" />
  </div>
</div>
`;
